<template>
    <div class="my-xl text-xxs">
        <div class="flex mb-md">
            <div class="flex-none flex flex-col items-center mr-md">
                <div
                    class="h-4xl w-4xl mb-sm"
                    :class="comment.author_has_custom_avatar ? 'overflow-hidden rounded-full' : ''"
                >
                    <img
                        v-if="comment.author_avatar_url"
                        :src="comment.author_avatar_url"
                        :alt="comment.author_name"
                        class="min-h-full min-w-full"
                    >
                </div>
                <template v-if="comment.author_latest_badges">
                    <div :class="{'flex ml-md' : comment.author_latest_badges.length > 1 }">
                        <img
                            v-for="badge in comment.author_latest_badges"
                            :key="badge.name"
                            :src="badge.image_url"
                            :alt="badge.label"
                            :title="badge.label"
                            class="h-xl"
                            :class="{ '-ml-md': comment.author_latest_badges.length > 1 }"
                        >
                    </div>
                    <div
                        v-if="comment.author_badge_count && comment.author_badge_count > comment.author_latest_badges.length"
                        class="-ml-xs text-center font-bold"
                    >
                        +{{ comment.author_badge_count - comment.author_latest_badges.length }}
                    </div>
                </template>
            </div>
            <div class="flex-grow">
                <div class="flex">
                    <h4 class="mb-0 flex items-center flex-wrap">
                        <template v-if="comment.author_public_profile_url">
                            <a :href="comment.author_public_profile_url">
                                {{ comment.author_name }}
                            </a>
                        </template>
                        <template v-else>
                            {{ comment.author_name }}
                        </template>

                        <img
                            v-if="comment.author_diet === 'plants'"
                            src="/img/diet-label-plants.svg"
                            title="Kost: Äter vegetariskt"
                            class="mb-px ml-sm"
                        >
                        <img
                            v-if="comment.author_diet === 'meat'"
                            src="/img/diet-label-mixed.svg"
                            title="Kost: Äter kött/blandkost"
                            class="mb-px ml-sm"
                        >

                        <template v-if="comment.author_title_label">
                            <span class="ml-sm font-normal">
                                {{ comment.author_title_label }}
                            </span>
                        </template>
                    </h4>
                </div>
                <div v-if="edit">
                    <comment-form
                        :product-id="comment.product_id"
                        :comment="comment"
                        :autofocus="true"
                    />
                </div>
                <div v-else class="relative">
                    <p
                        class="mt-sm bg-gray-100 rounded-lg p-md mb-0"
                    >
                        <span class="block mb-xs">{{ comment.text }}</span>
                        <span class="text-gray-700 opacity-75">{{ time }}</span>
                    </p>
                    <div v-if="! isAuthor" class="absolute bottom-0 right-0 -mr-xs -mb-xs">
                        <like-button :initial-comment="comment" />
                    </div>
                </div>
            </div>
        </div>

        <div
            class="flex justify-between items-center border-gray-100 mt-lg py-xs"
            :class="isAuthor ? 'border-t border-b' : 'border-b'"
        >
            <div class="flex">
                <template v-if="isAuthor">
                    <button
                        v-if="! edit"
                        type="button"
                        class="mr-md hover:underline"
                        @click="openEditForm"
                    >
                        Ändra
                    </button>
                    <button
                        v-if="edit"
                        type="button"
                        class="mr-md hover:underline"
                        @click="edit = false"
                    >
                        Avbryt
                    </button>

                    <danger-button
                        :modal-name="`delete-comment-${comment.id}`"
                        primary-button-text="Radera kommentaren"
                        :action="route('front.api.products.comments.destroy', [comment.product_id, comment])"
                        :redirect-to="route('front.products.show', productSlug)"
                        button-classes-override="text-danger-500 hover:underline"
                    >
                        Radera
                    </danger-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import DangerButton from '@/Atlantis/Elements/Buttons/DangerButton';
    import LikeButton from './LikeButton';

    export default {
        components: {
            DangerButton,
            LikeButton,
        },
        props: {
            comment: {
                type: Object,
                required: true,
            },
            productSlug: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                edit: false,
            };
        },
        computed: {
            time() {
                if (this.comment.edited_at) {
                    return `Ändrad ${this.comment.edited_at}`;
                }

                return this.comment.created_at;
            },
            isAuthor() {
                return window.App.userId && this.comment.author_user_id === window.App.userId;
            },
        },

        methods: {
            openEditForm() {
                this.edit = true;
                this.$nextTick(() => {
                    document.querySelector(`#comment-textarea-${this.comment.id}`).focus();
                });
            },
        },
    };
</script>
